import React from 'react';
import Fade from 'react-reveal/Fade';
import SocialContactItems from '../Contact/SocialContactItems';
import styles from './styles.module.scss';

function WelcomeBox() {
	return (
		<Fade bottom duration={5000} distance='0px'>
			<div className={`box ${styles.mainBox}`}>
				<div className={styles.innerContainer}>
					<div className={styles.welcomeText}>
						<h2>Hey, I am</h2>
						<h1>Sarah Abdelfattah</h1>
						<h3>CS Student</h3>
						<h3>Passionate coder</h3>
						<h3>Creative web developer</h3>
					</div>

					<div className={styles.socialDiv}>
						<SocialContactItems className='whiteSocialItems' />
					</div>
				</div>
			</div>
		</Fade>
	);
}

export default WelcomeBox;
